export enum ESortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
